// List of videos for a specific Mondelez Tour
export const mondelezTourVideos = [
  {
    lockName: 'Play welcome',
    videoId: 'Welcome Video (with treedis vids) [858920368].mp4',
  },
  {
    lockName: 'play green screen 2',
    videoId: 'video 2 [857421494].mp4',
  },
  {
    lockName: 'play green screen 3',
    videoId: 'STEP 1 - Mould Exchange [866415607].mp4',
  },
  {
    lockName: 'play green 4',
    videoId: 'video 4 - mould dipisotor [857421707].mp4',
  },
  {
    lockName: 'green screen 5',
    videoId: 'video 5 incpection point [857421938].mp4',
  },
  {
    lockName: 'green screen 6',
    videoId: 'video 6 carmael dipisotor [857422755].mp4',
  },
  {
    lockName: 'green screen 7',
    videoId: 'video 7 backs diposotor [857422740].mp4',
  },
  {
    lockName: 'green screen 8',
    videoId: 'video 8 demould station [857422804].mp4',
  },
  {
    lockName: 'green 9',
    videoId: 'last vidro [857422785].mp4',
  },
  {
    lockName: 'info loto',
    videoId: 'STEP 2.5 - LOTO v2 (summary version) [866418977].mp4',
  },
  {
    lockName: 'rewatch welcome',
    videoId: 'Welcome Video (with treedis vids) [858920368].mp4',
  },
  {
    lockName: 'rewatch green 2',
    videoId: 'video 2 [857421494].mp4',
  },
  {
    lockName: 'rewatch green 3',
    videoId: 'STEP 1 - Mould Exchange [866415607].mp4',
  },
  {
    lockName: 'rewatch  4',
    videoId: 'video 4 - mould dipisotor [857421707].mp4',
  },
  {
    lockName: 'rewatch 5',
    videoId: 'video 5 incpection point [857421938].mp4',
  },
  {
    lockName: 'rewatch 6',
    videoId: 'video 6 carmael dipisotor [857422755].mp4',
  },
  {
    lockName: 'rewatch 7',
    videoId: 'video 7 backs diposotor [857422740].mp4',
  },
  {
    lockName: 'rewatch 8',
    videoId: 'video 8 demould station [857422804].mp4',
  },
  {
    lockName: 'rewatch 9',
    videoId: 'last vidro [857422785].mp4',
  },
];

export const IOT_TOAST_CONFIG = {
  hideProgressBar: true,
  autoClose: 3000,
  closeOnClick: false,
  closeButton: false,
  style: {
    borderRadius: '3px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: '#fff',
    height: '40px',
  },
};
export const NYTIMES_TOUR_SLUGS = ['/bachar-family', '/nirit-hunwald-kornfeld'];
